import { render, staticRenderFns } from "./zoeken.vue?vue&type=template&id=6959decb&"
import script from "./zoeken.vue?vue&type=script&lang=js&"
export * from "./zoeken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,GeneralSearch: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Search.vue').default,GeneralSearchResult: require('/home/nvpa/nvpa-corporate/nuxt/components/general/SearchResult.vue').default})
